import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../components/nav/crowpay.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  Dialog1vemwbargnizv as Dialog,
  ProjectMessageThread3bzm1pe4dp4n as ProjectMessageThread,
} from '../../components/project/activity/messages.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { ProjectMessage3vmbacgk5u7x3 as ProjectMessage } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_project1t10doy5antl1 as get_project,
  get_sent1fielv150x6ow as get_sent,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectMessageFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import {
  get_lightSection4cpu8okr0w14 as get_lightSection,
  MessageSemantic26vy91vxbjwf0 as MessageSemantic,
} from '../../theming/sections.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  get_bold1rri6ahk98puv as get_bold,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  ProjectStateSemanticzawrm52z9108 as ProjectStateSemantic,
  GreyedOutSemantic_getInstancexltt5xem3a07 as GreyedOutSemantic_getInstance,
} from '../../theming/states.mjs';
import {
  divkhq3vjih9fcw as div,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { formatRelative8nj0p568e3ja as formatRelative } from '../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { shownDefaultFalse3hpz4awymyomc as shownDefaultFalse } from '../../../utils/utils.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { children3sl29z5no2wyp as children } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.ext.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  if (get_viewIsNarrow($this.ej8_1)) {
    var tmp = get_mainPageNavigator($this.ej8_1);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.fj8_1;
    var tmp_0 = await_0(this_0, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp$ret$0 = tmp_0;
    tmp.dbw(new (ProjectMessageThread())(tmp$ret$0.x7a_1, $this.gj8_1.mf8_1));
  } else {
    var tmp_1 = get_dialogStack();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.fj8_1;
    var tmp_2 = await_0(this_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp$ret$1 = tmp_2;
    tmp_1.xgd(new (Dialog())($this.gj8_1.mf8_1, tmp$ret$1));
  }
  return Unit_instance;
}
function MessagingScreen$projects$lambda($this$remember) {
  return $this$remember.baj($this$remember.baj(get_session()).qfw_1);
}
function MessagingScreen$render$lambda(it) {
  return it.x7a_1;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.wb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function Space$_get_shown_$ref_2vywof(p0) {
  return () => p0.wb8();
}
function Space$_set_shown_$ref_w6td2z(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var MessagingScreen$render$lambda$slambdaClass;
function MessagingScreen$render$lambda$slambda() {
  if (MessagingScreen$render$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, $project, this$0) {
        this.ej8_1 = $$this$button;
        this.fj8_1 = $project;
        this.gj8_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MessagingScreen$render$lambda$slambdaClass = $;
  }
  return MessagingScreen$render$lambda$slambdaClass;
}
function MessagingScreen$render$lambda$slambda_0($$this$button, $project, this$0) {
  var i = new (MessagingScreen$render$lambda$slambda())($$this$button, $project, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var MessagingScreenClass;
function MessagingScreen() {
  if (MessagingScreenClass === VOID) {
    class $ {
      constructor(lens) {
        this.mf8_1 = lens;
        var tmp = this;
        tmp.nf8_1 = remember(VOID, VOID, VOID, MessagingScreen$projects$lambda);
        var tmp_0 = this;
        tmp_0.of8_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var session = $this$remember.baj(get_session());
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.baj(this.nf8_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            // Inline function 'com.lightningkite.lightningdb.condition' call
            // Inline function 'com.lightningkite.lightningdb.path' call
            // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
            var tmp = serializerOrContextual(createKType(getKClass(ProjectMessage()), arrayOf([]), false));
            var tmp$ret$0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
            // Inline function 'kotlin.let' call
            var it = new (DataClassPathSelf())(tmp$ret$0);
            var tmp0_condition = eq(get_project(it), item.x7a_1);
            // Inline function 'com.lightningkite.lightningdb.sort' call
            // Inline function 'kotlin.apply' call
            var this_1 = new (SortBuilder())();
            // Inline function 'com.lightningkite.lightningdb.path' call
            // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
            var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectMessage()), arrayOf([]), false));
            var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
            var it_0 = new (DataClassPathSelf())(tmp$ret$5);
            this_1.n4a(get_sent(it_0));
            var tmp1_orderBy = this_1.o1r();
            var tmp$ret$11 = session.jfw_1.feo(new (Query())(tmp0_condition, tmp1_orderBy, VOID, 1));
            destination.v(tmp$ret$11);
          }
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0 = invokeAll($this$remember, destination);
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination_0 = ArrayList().w();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = tmp0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element = _iterator__ex2g4s_0.o1();
            var tmp0_safe_receiver = firstOrNull(element);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination_0.v(tmp0_safe_receiver);
            }
          }
          // Inline function 'kotlin.collections.associateBy' call
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_0, 10)), 16);
          // Inline function 'kotlin.collections.associateByTo' call
          var destination_1 = LinkedHashMap().fc(capacity);
          var _iterator__ex2g4s_1 = destination_0.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_0 = _iterator__ex2g4s_1.o1();
            var tmp$ret$23 = element_0.j7p_1;
            destination_1.s3(tmp$ret$23, element_0);
          }
          return destination_1;
        });
      }
      ud6(_this__u8e3s4) {
        var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        title(view, 'Message Threads');
        var tmp_0 = get_expanding(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.recyclerView' call
        // Inline function 'kotlin.apply' call
        var this_0 = new (Recycler2())(view, true);
        var tmp_1 = MessagingScreen$render$lambda;
        children(this_0, this.nf8_1, tmp_1, ($this$children, project) => {
          var recentMessage = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(this.of8_1).p3($this$remember.baj(project).x7a_1));
          var tmp = get_lightSection($this$children);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Button())($this$children.pc());
          var tmp0_elvis_lhs = $this$children.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$children : tmp0_elvis_lhs;
          $this$children.ebb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view_0.xbm(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.ebb(p_1, view_1);
          view_1.xbm(false);
          var tmp_0 = view_1.ibb(view_1.ibb(get_centered(view_1), get_expanding(view_1)), get_bold(view_1));
          // Inline function 'com.crowpay.views.theming.subTitle' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (TextView())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.ebb(p_2, view_2);
          view_2.jba(view_2.ob6_1.ybe(SubtitleSemantic_getInstance()));
          var tmp_1 = KMutableProperty0();
          var tmp_2 = TextView$_get_content_$ref_4pzcwl(view_2);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb(view_2));
          reactiveScope(view_2, ($this$reactiveScope) => {
            var tmp$ret$0 = $this$reactiveScope.baj(project).d7b_1;
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          view_1.fbb(p_2, view_2);
          view_1.jbb(tmp_0, view_2);
          var tmp_3 = get_centered(view_1);
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (TextView())(view_1.pc());
          var tmp0_elvis_lhs_3 = view_1.cbb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
          view_1.ebb(p_3, view_3);
          view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
          dynamicTheme(view_3, ($this$dynamicTheme) => ProjectStateSemantic().ch1($this$dynamicTheme.baj(project).w7b_1));
          var tmp_4 = KMutableProperty0();
          var tmp_5 = TextView$_get_content_$ref_4pzcwl_0(view_3);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_0(view_3));
          reactiveScope(view_3, ($this$reactiveScope) => {
            var tmp$ret$7 = $this$reactiveScope.baj(project).w7b_1.s9b_1;
            this_1.set(tmp$ret$7);
            return Unit_instance;
          });
          view_1.fbb(p_3, view_3);
          view_1.jbb(tmp_3, view_3);
          view_0.fbb(p_1, view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_4 = view_0.cbb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
          view_0.ebb(p_4, view_4);
          view_4.xbm(true);
          var tmp_6 = KMutableProperty0();
          var tmp_7 = RowOrCol$_get_shown_$ref_m8lfse(view_4);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_2 = getPropertyCallableRef('shown', 0, tmp_6, tmp_7, RowOrCol$_set_shown_$ref_7290m6(view_4));
          reactiveScope(view_4, ($this$reactiveScope) => {
            var tmp$ret$18 = !($this$reactiveScope.baj(recentMessage) == null);
            this_2.set(tmp$ret$18);
            return Unit_instance;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (RowOrCol())(view_4.pc());
          var tmp0_elvis_lhs_5 = view_4.cbb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
          view_4.ebb(p_5, view_5);
          view_5.xbm(true);
          view_5.zb8(div(view_5.kba().hb0_1, 2));
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (TextView())(view_5.pc());
          var tmp0_elvis_lhs_6 = view_5.cbb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
          view_5.ebb(p_6, view_6);
          view_6.jba(view_6.ob6_1.ybe(BodySemantic_getInstance()));
          dynamicTheme(view_6, ($this$dynamicTheme) => {
            var tmp0_safe_receiver = $this$dynamicTheme.baj(recentMessage);
            var clientMessage = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n7p_1) === true;
            return MessageSemantic().qgt(clientMessage === this.mf8_1.xgj());
          });
          var tmp_8 = KMutableProperty0();
          var tmp_9 = TextView$_get_content_$ref_4pzcwl_1(view_6);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_3 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb_1(view_6));
          reactiveScope(view_6, ($this$reactiveScope) => {
            var tmp0_safe_receiver = $this$reactiveScope.baj(recentMessage);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p7p_1;
            var tmp$ret$20 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
            this_3.set(tmp$ret$20);
            return Unit_instance;
          });
          view_5.fbb(p_6, view_6);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_7 = new (RowOrCol())(view_5.pc());
          var tmp0_elvis_lhs_7 = view_5.cbb_1;
          var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
          view_5.ebb(p_7, view_7);
          view_7.xbm(false);
          var tmp_10 = get_expanding(view_7);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_8 = new (Space())(view_7.pc());
          var tmp0_elvis_lhs_8 = view_7.cbb_1;
          var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
          view_7.ebb(p_8, view_8);
          var tmp_11 = KMutableProperty0();
          var tmp_12 = Space$_get_shown_$ref_2vywof(view_8);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_4 = getPropertyCallableRef('shown', 0, tmp_11, tmp_12, Space$_set_shown_$ref_w6td2z(view_8));
          reactiveScope(view_8, ($this$reactiveScope) => {
            var tmp0_safe_receiver = $this$reactiveScope.baj(recentMessage);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n7p_1;
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : equals(tmp1_safe_receiver, this.mf8_1.xgj());
            var tmp$ret$27 = tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
            this_4.set(tmp$ret$27);
            return Unit_instance;
          });
          view_7.fbb(p_8, view_8);
          view_7.jbb(tmp_10, view_8);
          // Inline function 'com.crowpay.views.theming.smallBody' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_9 = new (TextView())(view_7.pc());
          var tmp0_elvis_lhs_9 = view_7.cbb_1;
          var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
          view_7.ebb(p_9, view_9);
          view_9.jba(view_9.ob6_1.ybe(SmallBodySemantic_getInstance()));
          var tmp_13 = KMutableProperty0();
          var tmp_14 = TextView$_get_content_$ref_4pzcwl_2(view_9);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_5 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb_2(view_9));
          reactiveScope(view_9, ($this$reactiveScope) => {
            var tmp0_safe_receiver = $this$reactiveScope.baj(recentMessage);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o7p_1;
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : formatRelative(tmp1_safe_receiver);
            var tmp$ret$32 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
            this_5.set(tmp$ret$32);
            return Unit_instance;
          });
          view_7.fbb(p_9, view_9);
          view_5.fbb(p_7, view_7);
          view_4.fbb(p_5, view_5);
          view_0.fbb(p_4, view_4);
          var tmp_15 = view_0.hbb(GreyedOutSemantic_getInstance());
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_10 = new (TextView())(view_0.pc());
          var tmp0_elvis_lhs_10 = view_0.cbb_1;
          var p_10 = tmp0_elvis_lhs_10 == null ? view_0 : tmp0_elvis_lhs_10;
          view_0.ebb(p_10, view_10);
          view_10.jba(view_10.ob6_1.ybe(BodySemantic_getInstance()));
          shownDefaultFalse(view_10, ($this$shownDefaultFalse) => $this$shownDefaultFalse.baj(recentMessage) == null);
          view_10.bbs(Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value = 'No Messages';
          var tmp_16 = view_10.tb5_1;
          var tmp_17;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value) === 0) {
            tmp_17 = '\xA0';
          } else {
            tmp_17 = value;
          }
          tmp_16.fbu(tmp_17);
          view_0.fbb(p_10, view_10);
          view_0.jbb(tmp_15, view_10);
          view.fbb(p_0, view_0);
          onClick(view, 'View Messages', VOID, MessagingScreen$render$lambda$slambda_0(view, project, this));
          $this$children.fbb(p, view);
          return $this$children.jbb(tmp, view);
        });
        view.jbb(tmp_0, this_0);
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'MessagingScreen', VOID, VOID, [Page()]);
    MessagingScreenClass = $;
  }
  return MessagingScreenClass;
}
function invokeAll(_this__u8e3s4, items) {
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    _this__u8e3s4.aaj(item);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(items, 10));
  var _iterator__ex2g4s_0 = items.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item_0 = _iterator__ex2g4s_0.o1();
    var tmp$ret$0 = _this__u8e3s4.baj(item_0);
    destination.v(tmp$ret$0);
  }
  return destination;
}
//region block: exports
export {
  MessagingScreen as MessagingScreen3v4v784hye3oc,
};
//endregion

//# sourceMappingURL=MessagingScreen.mjs.map
